import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class DieselShutdownPumpDto extends InspectionCase {
  fuelTank?: InspectionCase;
  coolingSystem?: InspectionCase;
  batteriesCurrentVoltage?: InspectionCase;
  accumulatorsContacts?: InspectionCase;
  pressureDischarger?: InspectionCase;
  pumpSpeed?: InspectionCase;
  coolingWaterFlow?: InspectionCase;
}

export class DieselShutdownPump extends DieselShutdownPumpDto {
  constructor(data: DieselShutdownPumpDto = { title: 'משאבת כיבוי דיזל' }) {
    super(data);
    this.fuelTank = new InspectionCase({
      ...data.fuelTank,
      title: `מיכל הדלק מלא 2/3 לפחות`
    });
    this.coolingSystem = new InspectionCase({
      ...data.coolingSystem,
      title: `מערכת הקירור תקינה - זורמים מים לקירור?`
    });
    this.batteriesCurrentVoltage = new InspectionCase({
      ...data.batteriesCurrentVoltage,
      title: `מדי הזרם ומתח של המצברים במצב נורמלי`
    });
    this.accumulatorsContacts = new InspectionCase({
      ...data.accumulatorsContacts,
      title: `המגעים במצברים חופשיים מקורוזיה`
    });
    this.pressureDischarger = new InspectionCase({
      ...data.pressureDischarger,
      title: `פורק הלחץ (אם קיים) פורק למאגר`
    });
    this.pumpSpeed = new InspectionCase({
      ...data.pumpSpeed,
      title: `המשאבה פועלת במהירות הנדרשת`
    });
    this.coolingWaterFlow = new InspectionCase({
      ...data.coolingWaterFlow,
      title: `מי הקירור זורמים דרך הצינור המיועד לכך`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.fuelTank.isApplicable || this.fuelTank.isPassed) &&
        (!this.coolingSystem.isApplicable || this.coolingSystem.isPassed) &&
        (!this.batteriesCurrentVoltage.isApplicable ||
          this.batteriesCurrentVoltage.isPassed) &&
        (!this.accumulatorsContacts.isApplicable ||
          this.accumulatorsContacts.isPassed) &&
        (!this.pressureDischarger.isApplicable ||
          this.pressureDischarger.isPassed) &&
        (!this.pumpSpeed.isApplicable || this.pumpSpeed.isPassed) &&
        (!this.coolingWaterFlow.isApplicable ||
          this.coolingWaterFlow.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.fuelTank.getNotes(),
      ...this.coolingSystem.getNotes(),
      ...this.batteriesCurrentVoltage.getNotes(),
      ...this.accumulatorsContacts.getNotes(),
      ...this.pressureDischarger.getNotes(),
      ...this.pumpSpeed.getNotes(),
      ...this.coolingWaterFlow.getNotes()
    ];
  }
}
